import { Layers2, Check, CircleSlash2, CircleAlert } from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { Tabs } from "@shared/ui/tabs";
import React from "react";
import MeterReadingStatus from "./MeterReadingStatus";
import MeterReasonCodes from "./MeterReasonCodes";

function MeterReadersCodeLanding() {
  // KPI Cards configuration using QuickStatsCard
  const meterCodeKpiCards = [
    {
      title: "Total",
      count: 0,
      trendSummary: "Total meter codes in the system",
      trendDirection: "up" as const,
      icon: <Layers2 className="h-8 w-8 text-blue-500" />,
    },
    {
      title: "Normal",
      count: 0,
      trendSummary: "Meter codes indicating normal operation",
      trendDirection: "up" as const,
      icon: <Check className="h-8 w-8 text-green-500" />,
    },
    {
      title: "RCNT",
      count: 0,
      trendSummary: "Meter codes for reading cannot be taken",
      trendDirection: "down" as const,
      icon: <CircleSlash2 className="h-8 w-8 text-yellow-500" />,
    },
    {
      title: "Faulty",
      count: 0,
      trendSummary: "Meter codes indicating equipment faults",
      trendDirection: "down" as const,
      icon: <CircleAlert className="h-8 w-8 text-red-500" />,
    },
  ];

  const tabComponents = {
    status: {
      label: "Reading Status",
      shortLabel: "Status",
      component: <MeterReadingStatus />,
    },
    reasonCodes: {
      label: "Reason Codes",
      shortLabel: "Reasons",
      component: <MeterReasonCodes />,
    },
  };

  const urlMapping = {
    status: "reading-status",
    reasonCodes: "reason-codes",
  };

  return (
    <>
      <div className="pb-4">
        <div className="flex items-center gap-3">
          <h2 className="page-title">
            Meter Readers Code
          </h2>
        </div>
        <p className="page-subtitle">
          Manage unique codes and profiles assigned to meter readers for
          tracking and accountability.
        </p>
      </div>

      {/* KPI Summary Cards - Using loop with QuickStatsCard */}
      {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 pb-6">
        {meterCodeKpiCards.map((card, index) => (
          <QuickStatsCard
            key={index}
            title={card.title}
            count={card.count}
            trendSummary={card.trendSummary}
            trendDirection={card.trendDirection}
            icon={card.icon}
          />
        ))}
      </div> */}

      <Tabs
        defaultValue="status"
        tabComponents={tabComponents}
        urlMapping={urlMapping}
        tabsListClassName="grid grid-cols-2 gap-2"
        className="w-full"
      />
    </>
  );
}

export default MeterReadersCodeLanding;
